import React from "react";
import gpay from '../Assets/Images/gpay.jpg';
import qr from '../Assets/Images/qr.jpg';
import { motion } from 'framer-motion';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const Gpay = () => {
  const { t } = useTranslation();
  const flaws = useSelector((state) => state.auth.flaws);

  console.log(flaws);

  return (
    <motion.div className="flex flex-col justify-center items-center relative min-h-screen w-full px-4 py-8">
      <p className="my-5 text-center text-lg md:text-xl font-bold max-w-xl">
        {t('Send a screenshot of the receipt you paid to this whatsapp number +91 82483 69800 with your reference number.')}
      </p>

      <motion.div className="flex flex-col md:flex-row gap-6 w-full max-w-4xl justify-center items-center">
        <motion.div className="flex-shrink-0 w-48 sm:w-56 md:w-64">
          <img src={gpay} alt="GPay" className="w-full h-auto object-contain rounded-lg shadow-md" />
        </motion.div>
        <motion.div className="flex-shrink-0 w-48 sm:w-56 md:w-64">
          <img src={qr} alt="QR Code" className="w-full h-auto object-contain rounded-lg shadow-md" />
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default Gpay;